import { getLinkedOnlyProductIds } from "./menuLinkedRules.js";

const productId = (product) => String(product?.id || product?.productId || "").trim();

export const isAssistantStandaloneProduct = (product) =>
  Boolean(productId(product)) &&
  product?.active !== false &&
  (product?.visibleInMenu ?? product?.visible_in_menu ?? product?.active) !== false &&
  product?.linkedOnly !== true &&
  product?.linked_only !== true &&
  product?.isLinkedOnly !== true;

// Keep relation options for customization, but never use them as standalone dishes.
export const getAssistantMenuCatalog = (products = [], linkedRules = []) => {
  const availableProducts = (Array.isArray(products) ? products : []).filter(
    (product) => productId(product) && product?.active !== false
  );
  const linkedOnlyIds = getLinkedOnlyProductIds(
    Array.isArray(linkedRules) ? linkedRules : [],
    availableProducts
  );
  const catalog = availableProducts.map((product) =>
    linkedOnlyIds.has(productId(product)) ? { ...product, linkedOnly: true } : product
  );
  return {
    products: catalog,
    standaloneProducts: catalog.filter(isAssistantStandaloneProduct),
  };
};

export const restrictAssistantDecisionToMenu = (decision, standaloneProducts = []) => {
  const allowedIds = new Set(standaloneProducts.filter(isAssistantStandaloneProduct).map(productId));
  const visibleProductIds = (decision.visibleProductIds || []).filter((id) => allowedIds.has(id));
  const action = decision.action;
  const needsProduct = ["open_product", "add", "replace"].includes(action?.type);
  const targetIds = [action?.targetProductId, action?.productId].filter(Boolean);
  const invalidAction = (needsProduct && !targetIds.length) ||
    ((needsProduct || action?.type === "update_quantity") && targetIds.some((id) => !allowedIds.has(id)));
  const restricted = invalidAction || visibleProductIds.length !== (decision.visibleProductIds || []).length;
  return {
    ...decision,
    visibleProductIds,
    action: invalidAction ? null : action,
    ...(restricted ? {
      answer: "Esa opcion no esta disponible para pedir por separado. Elegi un plato de la carta y sus opciones dentro de ese plato.",
      suggestions: [],
    } : {}),
  };
};
